import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import {NgbTimepickerConfig, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { QuestionSetService } from '../services/questionset.service';
import { MatSlideToggleChange } from '@angular/material';
 
@Component({
  selector: 'app-edit-modal',
  templateUrl: './edit-modal.component.html',
  styleUrls: ['./edit-modal.component.scss'],
  providers: [NgbTimepickerConfig]
})
 
 
export class EditModalComponent implements OnInit {
  //  @Input() editData;
   
  minDate;
  startDate;
   editData:any;
   isDetailsRequired:boolean;
  
   localEditData: any;
  check_start_time;
  dup:any=[];
  past_time: boolean;
  datebtn: boolean;
  startbtn: boolean;
  endbtn: boolean;
 
  constructor(public activeModal: NgbActiveModal,private Config: NgbDatepickerConfig, config: NgbTimepickerConfig, private qs: QuestionSetService) {
    const currentYear = new Date().getFullYear();
    this.minDate = moment().format("YYYY-MM-DD");
    config.seconds = true;
    config.spinners = false;
   
   
 
  }
  setEditData(rowData: any): void {
    this.localEditData = { ...rowData };
    
    this.isDetailsRequired=rowData.isDetailsRequired
    
 
  }
  ngOnInit() {
   
 
    this.startDate = moment(this.localEditData.Start_Date).format("YYYY-MM-DD")

   
   ;
 
  }
 
 
  closeModal(sendData) {
   
 
    
   
   
   
    this.activeModal.close(sendData);
  }
 
  onChangeDate(startDate){
 
    this.localEditData.Start_Date = startDate;
   
  }
 
  saveScheduledetails(){
    this.localEditData.Start_Date = this.startDate
 
    this.compareDays();
    if(this.startbtn !== true && this.datebtn !== true && this.endbtn !== true && this.past_time  === false)
    {

 
      this.qs.update_schedule(this.localEditData).subscribe(
        (data) => {
          if (data.code === 200) {
          } else {
 
        }
        },
        err => {
          console.error(err);
        }
      );
     
      this.closeModal('saved')
    }
  }
 
  compareDays() {
    const dateObj = moment(this.localEditData.Start_Date).format("YYYY-MM-DD");
    
 
    const current_date = moment(); // Use moment() directly to get the current date and time
    
 
    const timeArr = this.localEditData.Start_Time.split(':');
 
 
    const date = moment()
      .set({
        hours: parseInt(timeArr[0]),
        minutes: parseInt(timeArr[1]),
        seconds: parseInt(timeArr[2]),
      })
      .toDate();
   
    const startTime = moment(date).format("h:mm:ss A");
    
 
    this.check_start_time = moment(dateObj + ' ' + startTime, "YYYY-MM-DD h:mm:ss A") .toISOString(true);
   
 
    
    if (current_date.isAfter(this.check_start_time)) {
      this.past_time = true;
    } else {
      this.past_time = false;
    }
 
 
    this.validateFields();
  }
 
 
 validateFields(){

  if(this.localEditData.Start_Date==''){
    this.datebtn=true
  }
  if(this.localEditData.Start_Time=='' ||this.localEditData.Start_Time < '0' || this.localEditData.Start_Time===null ){
    this.startbtn=true
  }
  if ((this.localEditData.Start_Time).toString() > (this.localEditData.End_Time).toString()) {
    this.past_time= true;
  } else {
    this.past_time = false;
  }
  if(this.localEditData.End_Time < '0' ||this.localEditData.End_Time=='' ||this.localEditData.End_Time===null ){
    this.endbtn=true
  }
 
  else{
    this.endbtn=false
  }
 
 }
 
 onChangeDetailsRequired(event: MatSlideToggleChange) {
  const isChecked = event?.source?.checked;
  this.isDetailsRequired = isChecked == true ? true : false
  
  this.localEditData.isDetailsRequired=this.isDetailsRequired
 
}
 
 
}